import getConfig from 'next/config';

const COLON = ':';
const ZENDESK = 'zendesk.com';

const {
  publicRuntimeConfig: {
    loginUrl: LOGIN_URL,
    siteUrl,
  },
} = getConfig();

// DEFAULT_HOST will be used in localhost only
const DEFAULT_HOST = 'www.binance.com';

const getHostNameWithPort = (req) => req ? req.get('host') :
  (typeof window !== 'undefined' && window.location.host) || DEFAULT_HOST;

export const getHostName = (req) => {
  const hostNameWithPort = getHostNameWithPort(req);
  return hostNameWithPort.indexOf(COLON) === -1 ?
    hostNameWithPort : hostNameWithPort.split(COLON)[0];
};

export const shouldUseAltUrl = req => {
  const hostname = getHostName(req);
  return hostname !== DEFAULT_HOST;
};

export const shouldUseAltWssUrl = req => shouldUseAltUrl(req);

export const getSuffix = () => (
  siteUrl.split('.')
    .slice(1)
    .join('.')
);

/*  the origin could be
    https://www.binance.sg => https://info.binance.com/
    https://www.binance.co.ug' => https://info.binance.com/
    https://www.binance.com => https://info.binance.com/
    https://www.binance.co => https://info.binance.co/ */
export const getInfoBase = (locale) => {
  const infoLocale = locale === 'cn' ? 'cn' : 'en';
  return `https://info.${getSuffix()}/${infoLocale}`;
};


export const getInfoApiBase = () => siteUrl;

export const getUrlParam = (key) => {
  if (typeof window !== 'undefined') {
    const search = window.location.search.substr(1);
    const params = search.split('&');
    for (let i = 0; i < params.length; i++) {
      const keyValueArray = params[i].split('=');
      if (key === keyValueArray[0]) {
        return keyValueArray[1];
      }
    }
  }
  return null;
};

export const getLoginUrl = (locale = 'en', callbackUrl = '') => `${LOGIN_URL.replace('%locale', locale)}${callbackUrl && `?callback=${callbackUrl}`}`;

// relative url cannot start with  // or /\ or \\ etc. as this will allow open redirect in javascript
// Example: //google.com
const relativePathRegx = new RegExp('^/$|^(/[\\w.?&=-]+[/\\w.?&=-]*)$');

// relative path
const checkRelative = (url) => relativePathRegx.test(url);

const checkAbsolute = (url) => {
  // todo white list remotely
  const whiteList = [
    'binance.com',
    'binance.net',
    'binance.co',
    'binance.vision',
    'binance.sg',
    'binance.co.ug',
    'binancezh.com',
    'binance.charity',
    'binance.zendesk.com',
    'binancesingapore.zendesk.com',
    'binanceuganda.zendesk.com',
  ];
  try {
    const callback = new URL(url);
    if (url.includes(ZENDESK)) {
      return !!whiteList.find(w => `${callback.protocol}//${w}` === callback.origin);
    }
    return !!whiteList.find(w => callback.origin.endsWith(`.${w}`));
  } catch (_) {
    return false;
  }
};

export const checkCallback = (url) => {
  /* to prevent payloads such as
  https://www.binance.com()@google.com
  https://google.com%5www.binance.com
  */
  if (url.includes('@') || url.includes('\\')) {
    return false;
  }

  // treat all url that do not start with http as relative url
  if (!url.startsWith('http')) {
    return checkRelative(url);
  }
  return checkAbsolute(url);
};
export const getHostUrl = (req) => {
  let url = '';
  if (typeof window === 'undefined') {
    url = `${req.protocol}://${req.get('host')}`;
  } else {
    url = window.location.origin;
  }
  return url;
};
